import React from "react";

const EXPLANATION =
  "Location and priority are simulated for this demo. They are not from real orders and are not set by the device.";

/**
 * The one "simulated" label a triage surface shows for its order context
 * (location, priority). Dashed secondary-category cue from AGENTS.md "State
 * encoding is non-hue": it marks the data as illustrative, not as a state.
 */
export const SimulatedLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span
    data-testid="simulated-order-label"
    title={EXPLANATION}
    className="shrink-0 rounded-xs border border-dashed border-border-strong px-1.5 py-px font-mono text-[9px] uppercase tracking-widest text-fg-muted"
  >
    {children}
  </span>
);
